export class ValueDomainItem {
  id= null;
  code= null;
  name= null;
  description= null;
  parent_code= null;
  level= null;
}
export class ValueDomain  {
  type= { 
    id: 75, 
    name: 'Described Value Domain',
    description: 'Jenis value domain yang nilai dinyatakan dalam bentuk ekspresi atau deskripsi'
  };
  classification_reference= null;
  items= [];
  total_levels= null;
}

export class Variable {
  id= null;
  code= null;
  name= null;
  definition= null;
  concepts= [];
  unit_types= [];
  measurement= null;
  measurement_unit= null;
  subject_field= null;
  value_domain= null;
  rule= null;
  references= [];
}
export class UpdatedVariable {
  changes_type=null;
	items=[];
}
export default class VariableSubmission{
  code= null;
  name= null;
  definition= null;
  concepts= [];
  unit_types= [];
  measurement= null;
  measurement_unit= null;
  subject_field= null;
  value_domain= new ValueDomain();
  rule= null;
  references= [''];
  updated_variable= null;
}